import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import {
    Elements,
    CardElement,
    useStripe,
    useElements
} from '@stripe/react-stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function PaymentForm({ amount, userId, onSuccess }) {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!stripe || !elements) {
            return;
        }

        setLoading(true);
        setError('');

        try {
            // 1. Create payment intent
            const token = localStorage.getItem('token');
            const { data } = await axios.post(
                'http://localhost:3000/create-payment-intent',
                { amount },
                { headers: { 'Authorization': `Bearer ${token}` } }
            );

            // 2. Confirm payment with Stripe
            const cardElement = elements.getElement(CardElement);
            const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(
                data.clientSecret,
                {
                    payment_method: {
                        card: cardElement,
                        billing_details: {
                            name: 'Shop Owner'
                        }
                    }
                }
            );

            if (stripeError) {
                setError(stripeError.message);
                setLoading(false);
                return;
            }

            // 3. Confirm payment on backend
            const confirmRes = await axios.post(
                'http://localhost:3000/confirm-payment',
                { paymentIntentId: paymentIntent.id },
                { headers: { 'Authorization': `Bearer ${token}` } }
            );

            if (confirmRes.data.success) {
                alert('✅ Payment successful! Your shop is now active!');
                onSuccess();
                navigate('/create-shop'); // Redirect to create shop
            }

        } catch (error) {
            setError(error.response?.data?.message || 'Payment failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="payment-form">
            <div className="payment-amount">
                <h3>Total: PKR {amount}</h3>
                <p>Pay to activate your shop for 1 month</p>
            </div>

            <div className="card-element-container">
                <CardElement 
                    options={{
                        style: {
                            base: {
                                fontSize: '16px',
                                color: '#424770',
                                '::placeholder': {
                                    color: '#aab7c4',
                                },
                            },
                            invalid: {
                                color: '#9e2146',
                            },
                        },
                    }}
                />
            </div>

            {error && <div className="payment-error">{error}</div>}

            <button 
                type="submit" 
                disabled={!stripe || loading}
                className="pay-btn"
            >
                {loading ? 'Processing...' : `Pay PKR ${amount}`}
            </button>

            <p className="payment-note">
                🔒 Secure payment powered by Stripe
            </p>
        </form>
    );
}

export default function Payment({ amount = 999, userId }) {
    const navigate = useNavigate();

    const handleSuccess = () => {
        // Refresh user data
        localStorage.removeItem('shop');
        navigate('/create-shop');
    };

    return (
        <div className="payment-page">
            <div className="payment-card">
                <h2>💰 Activate Your Shop</h2>
                <p>Pay once and get 1 month access to sell your products!</p>
                
                <Elements stripe={stripePromise}>
                    <PaymentForm 
                        amount={amount} 
                        userId={userId}
                        onSuccess={handleSuccess}
                    />
                </Elements>
            </div>
        </div>
    );
}